var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0acf83",
    d: "M71 187c16.008 0 29-12.992 29-29v-29H71c-16.008 0-29 12.992-29 29s12.992 29 29 29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a259ff",
    d: "M42 100c0-16.008 12.992-29 29-29h29v58H71c-16.008 0-29-12.992-29-29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f24e1e",
    d: "M42 42c0-16.008 12.992-29 29-29h29v58H71c-16.008 0-29-12.992-29-29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7262",
    d: "M100 13h29c16.008 0 29 12.992 29 29s-12.992 29-29 29h-29z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1abcfe",
    d: "M158 100c0 16.008-12.992 29-29 29s-29-12.992-29-29 12.992-29 29-29 29 12.992 29 29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma1);
export default __webpack_public_path__ + "static/media/figma1.318a00f8ccb71c0f3b3cc5640d28d87a.svg";
export { ForwardRef as ReactComponent };